import * as React from 'react';
import { SVGProps } from 'react';

const SvgForKnees = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="M35.541 28.921h-6.42l-.03-12.418 6.45-6.466V28.92Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M35.079 34.754H4.92A2.924 2.924 0 0 1 2 31.833v-.036a2.925 2.925 0 0 1 2.92-2.92h30.16a2.925 2.925 0 0 1 2.92 2.92v.035a2.925 2.925 0 0 1-2.92 2.922h-.001Z"
    />
    <path
      fill="currentColor"
      d="m8.981 27.857-1.49-1.629 3.994-3.658 2.516-5.8 7.618 4.445-3.183 6.158-1.962-1.014 2.22-4.295-3.657-2.131-1.713 3.948-4.343 3.976Z"
    />
    <path
      fill="currentColor"
      d="m11.64 22.344 1.704-8.573-2.114 1.057-.47 3.347L9 18l.234-4.051 4.992-4.17 4.698 1.585 1.233 2.996 3.7-.118.118 1.937-4.582.822-1.115-2.407-.47 3.289 3.759 3.347-6.283-2.643-3.643 3.758Zm5.68-17.969h-.375a2.074 2.074 0 0 0-2.073 2.074v1.196c0 1.146.928 2.074 2.073 2.074h.375a2.074 2.074 0 0 0 2.074-2.074V6.45a2.074 2.074 0 0 0-2.074-2.074Z"
    />
    <path stroke="currentColor" strokeWidth={1.5} d="m27.07 17.47 8-8" />
  </svg>
);

export default SvgForKnees;
